import { tsoPqTheme } from '@assets/style/customTsoPqtheme';
import { styled } from '@mui/material';
import { TreeItem } from '@mui/x-tree-view';

export const StyledTreeItem = styled(TreeItem, {
  shouldForwardProp: (prop) => !['leftIcon'].includes(prop as string),
})(({ leftIcon }: { leftIcon: boolean }) => {
  return {
    '& .MuiTreeItem-content': {
      background: 'transparent',
      padding: '0.375rem 1.125rem',
      '&:hover': {
        borderRadius: 0,
        background: tsoPqTheme.palette.background.neutral.color_neutral_background_bg_ntrl_accent,
        '& .MuiButtonBase-root': {
          display: 'flex',
        },
      },
      '&:active': {
        background: tsoPqTheme.palette.background.primary.color_primary_background_bg_prim,
      },
      '&.Mui-selected': {
        borderRadius: 0,
        background: tsoPqTheme.palette.background.primary.color_primary_background_bg_prim,
        '&:hover': {
          background: `${tsoPqTheme.palette.background.neutral.color_neutral_background_bg_ntrl_accent} !important`,
        },
      },
      '&.Mui-focused.Mui-selected': {
        background: tsoPqTheme.palette.background.primary.color_primary_background_bg_prim,
        '&:hover': {
          background: `${tsoPqTheme.palette.background.neutral.color_neutral_background_bg_ntrl_accent} !important`,
        },
      },
      '& .MuiTreeItem-iconContainer	': {
        color: tsoPqTheme.palette.customTextColor.color_primary_font_ft_prim_accent,
        '& svg': { fontSize: '2.125rem' },
      },
    },
    '& .MuiTreeItem-content.Mui-focused': {
      borderRadius: 0,
      background: tsoPqTheme.palette.background.primary.color_primary_background_bg_prim,
      '& .MuiButtonBase-root': {
        display: 'flex',
      },
      '&:hover': {
        background: `${tsoPqTheme.palette.background.neutral.color_neutral_background_bg_ntrl_accent} !important`,
      },
    },
    '& .MuiCollapse-root': {
      padding: '0 0 0 2.625rem',
    },
    '& .MuiTreeItem-label': {
      '& .MuiButtonBase-root': {
        display: leftIcon ? 'flex' : 'none',
      },
    },
  };
});
